export default "__VITE_ASSET__Bn7ewtLw__"